import { Tag } from 'antd/lib'

type ExamProgressTagProps = {
    isTimeLimitSet: boolean
    timeLeftInMins?: number
}

export const ExamProgressTag = ({ isTimeLimitSet, timeLeftInMins }: ExamProgressTagProps) => {
    let tagText = 'INPROGRESS'
    if (isTimeLimitSet) {
        tagText = `INPROGRESS - ${timeLeftInMins} mins left`
    }
    return (
        <Tag bordered={true} color="orange">
            {tagText}
        </Tag>
    )
}
